
import React from 'react';
import { NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalTemplate } from 'themes/application/niko-facility-order-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore } from 'application/niko-facility-order-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore(rootStore, componentProps), 'nikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalStore')
@observer
class NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModal extends React.Component {
    render() {
        return <NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModalTemplate {...this.props} />
    }
}

export default NikoFacilityOrderUSIntakeFindAndDeleteConfirmationModal;
